import React from 'react';

import { Bloc, BlocContent } from '../../routes/project/components/step-drawer';
import { timeParser } from '../../lib/utils/time-parser';
import { openModal } from '../../core/modal/open-modal';
import { EstimatedTimeSelector } from '../../features/schedule/components/EstimatedTimeSelector';

interface TimeInputProps {
  value?: number;
  onChange: (value: number) => void;
  label?: string;
}

export const TimeInputDrawer: React.FC<TimeInputProps> = ({ value, label, onChange }) => {
  const openTimeModal = () => {
    openModal(EstimatedTimeSelector, {
      onTimeChange: onChange,
      time: value,
    });
  };

  return (
    <Bloc onClick={openTimeModal} data-row={true}>
      <label>{label}</label>

      <BlocContent>{timeParser(value || 0).toString()}</BlocContent>
    </Bloc>
  );
};
